import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import FundamentalsBoard from "./economic-calendar/FundamentalsBoard";
import MarketInternalsBoard from "./market-overview/MarketInternalsBoard";

import BaseLayout from "../layouts/BaseLayout";
import MarketOverview from "./market-overview/MarketOverview";
import EconomyPage from "./economy/EconomyPage";
import IntermarketPage from "./intermarket/IntermarketPage";
import SeasonalityPage from "./seasonality/SeasonalityPage";
import Metrics from "./metrics/Metrics";
import UpcomingEvents from "./upcoming-events/UpcomingEvents";
import ChartAnalysis from "./chart-analysis/ChartAnalysis";

import ProfileSettings from "./profile-settings/ProfileSettings";
import Login from "./login/Login";
import { JournalProvider } from "../context/JournalContext";
import { MarketOverviewProvider } from "../context/MarketOverviewContext";
import { useSelector } from 'react-redux';

const AppRoutes = () => {
    const { isAuthenticated } = useSelector((state) => state.auth);

    return (
        <MarketOverviewProvider>
            <JournalProvider>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<Navigate to={isAuthenticated ? "/economy" : "/login"} replace />} />

                    {isAuthenticated && (
                        <Route path="*" element={
                            <BaseLayout>
                                <Routes>
                                    <Route path="/fundamentals" element={<FundamentalsBoard />} />
                                    <Route path="/market-internals" element={<MarketInternalsBoard />} />
                                    <Route path="/market-overview" element={<MarketOverview />} />
                                    <Route path="/economy" element={<EconomyPage />} />
                                    <Route path="/intermarket" element={<IntermarketPage />} />
                                    <Route path="/seasonality" element={<SeasonalityPage />} />
                                    <Route path="/chart-analysis" element={<ChartAnalysis />} />
                                    <Route path="/upcoming-events" element={<UpcomingEvents />} />
                                    <Route path="/metrics" element={<Metrics />} />
                                    <Route path="/profile" element={<ProfileSettings />} />
                                    <Route path="*" element={<Navigate to="/economy" replace />} />
                                </Routes>
                            </BaseLayout>
                        } />
                    )}

                    {!isAuthenticated && (
                        <Route path="*" element={<Navigate to="/login" replace />} />
                    )}
                </Routes>
            </JournalProvider>
        </MarketOverviewProvider>
    );
};

export default AppRoutes;